import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const courses = [
    {
        title: "Executive PG Program in DevOps Job-Ready Program",
        desc: "Get Microsoft and AWS certification with advanced DevOps and multi-cloud training.",
        url: "/devops-training-online",
        img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAdVBMVEXz8/PzUyWBvAYFpvD/ugjz9fb19Pbz+fr39fr69vPy9frzRQAAofD/tgDz2dLg6c55uQDzTBfzmYaw0X370H3N5vL16c59xfHz497n7dzzPQDzk36s0HXb6/N1wvH7znX07dwAnvDw8uzzvLHK3qys1vL43qwIyvd5AAABeklEQVR4nO3cSW7CUBBFUdIYHGz63jQG0ux/iZkEB4kvZVR2BuduoHRU89frSZKku7LwmlP98JLCcXTbG7G/m0R3TXxwXBWxVfvBz638MI1u8vjFbFw8xTabN8LFc3CEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISE7QqrWWzFnXDahXC7nwf3ftugzT8WwR12iZ3dbBDd745wHl56SFiSpD97C685NQwvSwCPp01sp88bcfhVL2Orzwni6lIGd2qE9Si6dUpYvsRWbhrhcvQaGyEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhIWG7wuj90kvX+6XZKrpjc+q8ju76CGy1LLyOgZIk/bO+AUuARNzIJsaAAAAAAElFTkSuQmCC"
    },
    {
        title: "DevOps & Cloud with GenAI Job-Ready Program",
        desc: "Master DevOps, cloud, and GenAI with hands-on real-world projects.",
        url: "/devops-and-cloud-training-online",
        img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAdVBMVEXz8/PzUyWBvAYFpvD/ugjz9fb19Pbz+fr39fr69vPy9frzRQAAofD/tgDz2dLg6c55uQDzTBfzmYaw0X370H3N5vL16c59xfHz497n7dzzPQDzk36s0HXb6/N1wvH7znX07dwAnvDw8uzzvLHK3qys1vL43qwIyvd5AAABeklEQVR4nO3cSW7CUBBFUdIYHGz63jQG0ux/iZkEB4kvZVR2BuduoHRU89frSZKku7LwmlP98JLCcXTbG7G/m0R3TXxwXBWxVfvBz638MI1u8vjFbFw8xTabN8LFc3CEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISE7QqrWWzFnXDahXC7nwf3ftugzT8WwR12iZ3dbBDd745wHl56SFiSpD97C685NQwvSwCPp01sp88bcfhVL2Orzwni6lIGd2qE9Si6dUpYvsRWbhrhcvQaGyEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhIWG7wuj90kvX+6XZKrpjc+q8ju76CGy1LLyOgZIk/bO+AUuARNzIJsaAAAAAAElFTkSuQmCC"
    },
    {
        title: "DevOps Certification Training Program",
        desc: "Learn CI/CD, Kubernetes, and Docker with real-world DevOps projects.",
        url: "/devops-certification-training",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJJeHenPcS52YkkAxqrcU5NPWbibMosmwwIw&s"
    },
    {
        title: "AWS Certification Training",
        desc: "Design scalable, secure AWS architectures with hands-on practical experience.",
        url: "/aws-solution-architect",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1EyLHVr04mrdRU1VYkVycQPfd_6VbxgaALw&s"
    },
    {
        title: "Azure Certification Training",
        desc: "Build, deploy, and manage applications using Microsoft Azure cloud services.",
        url: "/microsoft-azure",
        img: "https://img.icons8.com/fluent/1200/azure-1.jpg"
    },
    {
        title: "GCP Certification Training",
        desc: "Master Google Cloud services for scalable, high-performance modern applications.",
        url: "/google-cloud-platform",
        img: "https://img.icons8.com/color/512/google-cloud.png"
    },
];

export default function CoursesGrid({ isSmallScreen }) {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                background: "#f7f4f8",
                py: isSmallScreen ? 4 : 8,
                display: "flex",
                justifyContent: "center",
            }}
        >
            {/* Container */}
            <Box
                sx={{
                    width: isSmallScreen ? "95%" : "70%",
                }}
            >
                {/* Heading */}
                <Typography
                    sx={{
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        fontSize: isSmallScreen ? "1.5rem" : "40px",
                        mb: 2,
                        lineHeight: 1.2,
                    }}
                >
                    Start with the course you need, or {!isSmallScreen && <br />}master them all
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "Poppins",
                        opacity: 0.7,
                        mb: 5,
                        fontSize: isSmallScreen ? "14px" : "16px",
                        maxWidth: "600px",
                    }}
                >
                    Every program is designed to make you job-ready with real-world skills.
                </Typography>

                {/* Grid */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 1fr",
                        columnGap: isSmallScreen ? "1.5rem" : "4rem",
                        rowGap: isSmallScreen ? "2rem" : "3rem",
                    }}
                >
                    {courses.map((course, index) => (
                        <motion.div
                            key={index}
                            whileHover={{ y: -4 }}
                            transition={{ duration: 0.2 }}
                        >
                            <Box
                                onClick={() => navigate(course.url)}
                                sx={{
                                    display: "flex",
                                    gap: "1rem",
                                    borderTop: "1px solid #e5e5e5",
                                    pt: "1.5rem",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    "&:hover": {
                                        opacity: 0.9,
                                    },
                                }}
                            >
                                {/* Icon */}
                                <Box
                                    sx={{
                                        width: 56,
                                        height: 56,
                                        borderRadius: "14px",
                                        background: `
                                        url(${course.img})
                                      `,
                                        backgroundSize: "cover, 60%",
                                        mixBlendMode: "multiply",
                                        flexShrink: 0,
                                    }}
                                />

                                {/* Content */}
                                <Box>
                                    <Typography
                                        sx={{
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            fontSize: isSmallScreen ? "16px" : "18px",
                                        }}
                                    >
                                        {course.title}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontFamily: "Poppins",
                                            fontSize: isSmallScreen ? "12px" : "14px",
                                            opacity: 0.7,
                                            mt: 0.5,
                                            maxWidth: "420px",
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        {course.desc}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontFamily: "Poppins",
                                            mt: 1.5,
                                            fontSize: isSmallScreen ? "12px" : "14px",
                                            fontWeight: 500,
                                            display: "inline-block",
                                            borderBottom: "2px solid #f59e0b",
                                        }}
                                    >
                                        Explore program →
                                    </Typography>
                                </Box>
                            </Box>
                        </motion.div>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}